import * as React from 'react';

import { BaseComponent } from '@fluentui/react';
import {Icon} from '@fluentui/react';
import { TagPicker, ITag } from '@fluentui/react';
import Api from '../../../services/Api'

export interface ITagPickerDemoPageState {
    isPickerDisabled?: boolean;
}

export class ItemPicker extends BaseComponent<{}, ITagPickerDemoPageState> {

    constructor(props: {}) {
        super(props);
        this.state = {
            isPickerDisabled: false,
            stopReloading : false
        };
        this.possibilities = [];
    }

    mapSelectionForItem(selection) {
        return { key: selection.key, name: this._getValueFromItem(selection) }
    }

    render() {
        //const isParent = this.props.selection != null && this.props.selection.hasOwnProperty('isParent') ? true : false;

        const currentSelection = this.props.isMultiValue 
            ? this.props.selection.map(x => this.mapSelectionForItem(x))
            : this.props.selection
                ? [this.mapSelectionForItem(this.props.selection)]
                : []

        const warningIcon = <div className={`warning-inline warning-${this.props.searchTitle ? 'withlabel' : 'nolabel'}-basepicker`} title="Field cannot be empty"><Icon  iconName="Warning"/></div>

        const warning = this.props.isRequired && currentSelection.length === 0 ? warningIcon : null;
        
        const pickerStyle = {
            input: {
                marginRight: 20
            },
            text: {
                paddingRight: !this.props.additionalIcon ? 'unset' : 26
            }
        }

        return (
            <div style={{...this.props.style, flex: 1, position: 'relative'}}>
                {this.props.searchTitle && <div style={{fontSize:'14px', margin:'16px 0 6px', fontWeight:'normal'}}>{this.props.searchTitle}</div>}
                {warning}
                <div className={`absoluteIcon warning-${this.props.searchTitle ? 'withlabel' : 'nolabel'}-basepicker`}>
                    {this.props.additionalIcon}
                </div>
                <TagPicker
                    onResolveSuggestions={this.getItemsFromSearch}
                    getTextFromItem={this._getTextFromItem}
                    //onItemSelected={this._onItemSelected}
                    onChange={this.onChangeSelection}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: 'Items to pick',
                        noResultsFoundText: 'No results found'
                    }}
                    selectedItems={currentSelection}
                    itemLimit={this.props.isMultiValue ? undefined : 1}
                    disabled={this.props.isPickerDisabled}
                    resolveDelay={300}
                    styles={pickerStyle}
                />
            </div>
        );
    }

    getItemsFromSearch = (searchText, items) => {
        if(!searchText)
            return items;

        const url = this.props.url + searchText;
        return new Promise((resolve) => {
            this.getItems(url, (err, results) => {
                if (!err) {
                    let options = results.filter(x => !items.map(i => i.key).includes(x.key)).map(item => ({
                            key: item.key,
                            name: this._getValueFromItem(item)
                        })
                    );
                    resolve(options);
                }
            });
        });
    }

    getItems(url, callback) {
        Api.get(url)
            .then(res => res.data)
            .then(items =>
                {
                    if (this.props.additionalOptions)
                        items = [...this.props.additionalOptions, ...items]

                    this.possibilities = items;
                    callback(null, items);
                }
            ).catch((error) => {
                callback(error, null)
            });
    }

    onChangeSelection = (items?: ITag[]) => {
        if (this.props.isMultiValue) {
            const mappedItems = items.map(x => this.possibilities.find(p => p.key === x.key) || [...this.props.selection].find(p => p.key === x.key))
            this.props.itemSelector(mappedItems);
        } else {
            const mappedItem = items.map(x => this.possibilities.find(p => p.key === x.key)).find(Boolean) || null
            this.props.itemSelector(mappedItem);
        }
    };

    _getValueFromItem(item) {
        return !this.props.keyHidden && item.key !== item.value && item.key !== 'Cross' 
            ? `${item.key} - ${item.value}` 
            : item.value;
    }

    _getTextFromItem(item: ITag): string {
        return item.name;
    }

     _onFilterChanged = (filterText: string, tagList: ITag[]): ITag[] => {
        this.getItemsFromSearch(filterText);

        return filterText
            ? this.possibilities
                .filter(tag => tag.name.toLowerCase().startsWith(filterText.toLowerCase()))
            : [];
    };

    // _onItemSelected = (item: ITag): ITag | null => {
    //     var chosenItem = this.possibilities.filter(p => p.key === item.key)[0];
    //     this.props.itemSelector(chosenItem);

    //     return item;
    // };
}


// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/ItemPicker.js